
<template>

    <div class="container">
        <div class="row ">
            
            <div class="col-12 text-center f_26 font_semibold mt-4">
                PLEASE CHOOSE A GAME TO CONTINUE
            </div>

            <div v-for="game in games" :key="game.gameId" class="col-6 mt-4 ">
                <div class="card p-4">
                    <div class="row">
                        <div class="col-5"><img :src="'https://taktic-indice.site/api/'+game.gameImage" width="100%"></div>
                        <div class="col-7">
                            <div class="f_18 font_medium">{{game.gameName_en}}</div>
                            <div class="f_18 font_medium mt-2">{{game.gameName_fr}}</div>
                            <hr>
                            <div>Duration: {{game.duration}} minutes</div>
                            <hr>
                            <select  v-model="langSelect" class="form-control" id="exampleFormControlSelect1">
                                <option value="en">English</option>
                                <option value="fr">French</option>
                            </select>

                            <button v-if="game.status != 'started'" type="button" @click="startGame(game.gameId)" class="btn btn-success mt-2 btn-block">Start the Game</button>
                            <button v-if="game.status == 'started'" type="button" @click="continueGame(game.gameId)" class="btn btn-warning mt-2 btn-block">Continue Game</button>

                        </div>
                    </div>
                    
                </div>
            </div>


        </div>
        <div class="powered">Powered by Escapist</div>
    </div>




</template>


<style lang="scss">
@import '~@/styles/home.css';
</style>

<script>

import { initializeApp } from "firebase/app";
import { getDatabase,onValue,ref,set,serverTimestamp } from "firebase/database";
import store from '../store/index'


const config = {
    apiKey: "AIzaSyBILrykfyUwQ7jA92zWjAwq3vK1PzNHBCQ",
    authDomain: "escapist-france-a53c2.firebaseapp.com",
    databaseURL: " https://escapist-france-a53c2-default-rtdb.firebaseio.com",
    projectId: "escapist-france-a53c2",
    storageBucket: "escapist-france-a53c2.appspot.com",
    messagingSenderId: "135622445342",
    appId: "1:135622445342:web:74db1f2cad55e66e43a10f"

};

const f_app = initializeApp(config);
const db = getDatabase(f_app);
//const dbRef = ref(db);



export default {

    components:{
        
    },

    data(){
        return {
            games : [],
            langSelect : "en"
        }
    },

    methods:{

        startGame(id){

            console.log(this.langSelect);
            set(ref(db, 'games/'+id+"/status"), "started");
            set(ref(db, 'games/'+id+"/started"), "1");
            set(ref(db, 'games/'+id+"/lang"), this.langSelect);
            set(ref(db, 'games/'+id+"/started_time"), serverTimestamp());
            this.$router.push('/master/game/'+id);
        },
        continueGame(id){
            this.$router.push('/master/game/'+id);
        },
            
        getGames(){

            
            const refLastOpen = ref(db, "games");
            onValue(refLastOpen, (snapshot) => {
                if (snapshot.exists()) {

                    this.games = [];

                    snapshot.forEach(e => {
                        console.log(e.val());
                        this.games.push(e.val());

                    }); 

                } 
            });

            console.log(this.games);

        },
        
        randName(){
            var result           = '';
            var characters       = 'abcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < 12; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * 
            charactersLength));
            }
            return result;
        },


        
    },

    mounted () {
        this.getGames();

        if(!store.getters.getMasterLogin){
            this.$router.push('/master');
        }
    },

    
};


</script>

